// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"394":"codebuild","640":"pipelines"}[chunkId] + "." + {"394":"d65c1693","640":"2f4a3d73"}[chunkId] + ".css";
};